const area1 = require("../../assets/images/area1.jpg");
const area2 = require("../../assets/images/area2.jpg");
const area3 = require("../../assets/images/area3.jpg");
const area4 = require("../../assets/images/area4.jpg");
const area5 = require("../../assets/images/area5.jpg");
const area6 = require("../../assets/images/area6.jpg");
const area7 = require("../../assets/images/area7.jpg");
const area8 = require("../../assets/images/area8.jpg");

const AreasOfWork = [
  {
    name: "Process Engineering",
    image: area8,
    url: "/business",
    id: "#process",
  },
  {
    name: "Piping Engineering ",
    image: area1,
    url: "/business",
    id: "#piping",
  },
  {
    name: "Mechanical Engineering",
    image: area2,
    url: "/business",
    id: "#mechanical",
  },
  {
    name: "Civil & Structural Engineering",
    image: area4,
    url: "/business",
    id: "#civil",
  },
  {
    name: "Electrical Engineering",
    image: area6,
    url: "/business",
    id: "#electrical",
  },
  {
    name: "Flow Assurance Service",
    image: area5,
    url: "/business",
    id: "#flow",
  },
  {
    name: "Instrumentation Engineering",
    image: area3,
    url: "/business",
    id: "#instrumentation",
  },
  {
    name: "Other Services",
    image: area7,
    url: "/business",
    id: "#other",
  },
];

export default AreasOfWork;
